import { useTranslations } from '@vocab/react';
import { Box, Column, Columns, Disclosure, Text } from 'braid-design-system';
import type { FC } from 'react';

import { SparklingBadgeAnimation } from 'src/libs/AnimatedIcons';
import { MarkdownContent } from 'src/libs/MarkdownContent';

import translations from './.vocab';
import { HighFitDisclaimerTooltip } from './HighFitDisclaimerTooltip';

import * as styles from './HighFitDisclosure.css';

type HighFitDisclosureProps = {
  id: string;
  summary: string;
  isExpanded: boolean;
  onDisclosureClicked: () => void;
};

export const HighFitDisclosure: FC<HighFitDisclosureProps> = ({
  id,
  summary,
  isExpanded,
  onDisclosureClicked,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Columns space="none">
        <Column width="content">
          <Text
            icon={
              <Box className={styles.iconContainer}>
                <SparklingBadgeAnimation loop={3} animateOnView />
              </Box>
            }
          />
        </Column>
        <Column>
          <Disclosure
            expandLabel={t('Why is this applicant high-fit?')}
            size="small"
            expanded={isExpanded}
            onToggle={onDisclosureClicked}
            id={id}
          >
            <Box paddingTop="xxsmall">
              <Columns space="none">
                <Column width="content">
                  <Box className={styles.aiCallout} />
                </Column>
                <Column>
                  <HighFitDisclaimerTooltip>
                    <MarkdownContent content={summary} />
                  </HighFitDisclaimerTooltip>
                </Column>
              </Columns>
            </Box>
          </Disclosure>
        </Column>
      </Columns>
    </Box>
  );
};
